const RPC_NODE = { url: 'https://api.hive.blog' }
const APP_VERSION = 'multisignature/0.0.1'
const URL_SIGN = './#/sign'

const STEEM_ADDRESS_PREFIX = "STM";

export default {
  RPC_NODE: RPC_NODE,
  APP_VERSION: APP_VERSION,
  URL_SIGN: URL_SIGN,
  STEEM_ADDRESS_PREFIX: STEEM_ADDRESS_PREFIX,
}
